import { createContext, useContext } from "react";
import type { PublicQuote } from "@forgepoint/shared";
import { QuoteDocumentContextError } from "./errors";
import type { DocumentAssetUrls } from "./types";

/** Document-wide data made available to every rendered fp-* component. */
export interface QuoteDocumentContextValue {
  quote: PublicQuote;
  assetUrls: DocumentAssetUrls;
  footerPageOffset: number;
  /** True in the editor, where hidden conditional blocks stay drawn. */
  editable: boolean;
}

/** Context carrying the quote data, resolved asset URLs, and page offset. */
export const QuoteDocumentContext =
  createContext<QuoteDocumentContextValue | null>(null);

/**
 * Returns the current document context. Only valid inside QuoteDocumentRenderer.
 * @returns The document context value
 */
export function useQuoteDocumentContext(): QuoteDocumentContextValue {
  const value = useContext(QuoteDocumentContext);
  if (!value) {
    throw new QuoteDocumentContextError(
      "useQuoteDocumentContext must be used within a QuoteDocumentRenderer",
    );
  }
  return value;
}
